import styled from "styled-components";

export const CategoryWrap = styled.div`
  display: flex;
  flex-direction: column;
  height: 90vh;
  width: 100%;
`;
